import React, { Component, Fragment } from "react";
import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  checkPrivileges,
  errorHandler,
  getAmUserId,
} from "../../../../Helpers";
import { updateUser, parentUsersLimit } from "../../../../Actions/Users";
import { updateAccount } from "../../../../Actions/Accounts";
import { validEmailPattern } from "../../../../Helpers";
import { parentUnitsLimit } from "../../../../Actions/Devices";
import AddUserModal from "../../addUserModal";
import isEqual from "react-fast-compare";
import MarkerMap from "../../../common/Maps";
import CustomDialog from "../../../common/Dialog";
import { checkUnitsWithStandardType } from "../../userDataTypes";
import { ServerInfo } from "../../../../Actions/serverSetting";
import instance from "../../../../axios";

const userDataFormat = (data, extAttriubtes, itemId) => {
  let formattedData = {
    city: data.city ? data.city : "",
    administrator: data.userType === 1 ? false : true,
    attributes: extAttriubtes ? extAttriubtes : {},
    coordinateFormat: data.coordinateFormat ? data.coordinateFormat : "",
    deviceLimit: data.deviceLimit ? data.deviceLimit : "",
    deviceReadonly:
      data.deviceReadonly === "on" || data.deviceReadonly === true
        ? true
        : false,
    disabled: data.disabled === "on" || data.disabled === true ? true : false,
    email: ("" + data.email).trim(),
    expirationTime: data.expirationTime ? data.expirationTime : null,
    id: itemId ? itemId : 0,
    latitude: data.latitude ? data.latitude : 0,
    limitCommands:
      data.limitCommands === "on" || data.limitCommands === true ? true : false,
    login: data.login,
    longitude: data.longitude ? data.longitude : 0,
    map: data.map,
    name: ("" + data.name).trim(),
    phone: data.phone,
    poiLayer: data.poiLayer,
    readonly: data.readonly === "on" || data.readonly === true ? true : false,
    token: data.token,
    twelveHourFormat:
      data.twelveHourFormat === "on" || data.twelveHourFormat === true
        ? true
        : false,
    userLimit: data.userLimit ? data.userLimit : "",
    vehicleLimit: data.vehicleLimit ? data.vehicleLimit : "",
    //creditLimit: data.creditLimit ? data.creditLimit : '',
    zoom: data.zoom ? data.zoom : 0,
    roleId: data.roleId || 0,
    userType: parseInt(data.userType),
    parentId: data.parentId || 0,
    activeDate:data?.activeDate||"",
    inactiveDate:data?.inactiveDate||""
    // active:data.active || true
  };
  if (data.customerType) {
    formattedData.customerType = parseInt(data.customerType);
  }
  return formattedData;
};

const accountDataFormat = (data, form, attributes) => {
  let newAttributes = {
    c_buildingNoArabic: "",
    c_addressArabic: "",
    c_streetNameArabic: "",
    c_cityArabic: "",
    ...attributes,
  };
    if (form?.userType === 3) {
    newAttributes.accountControl = Boolean(attributes?.accountControl);
  }
  if(form.status==="credit"){
    newAttributes.c_agreedAdvancePayment=0
  }
   if(!newAttributes.c_agreedAdvancePayment){
    newAttributes.c_agreedAdvancePayment=0
  }
  delete newAttributes.c_am;
  const amUserId = getAmUserId({ form, account: data });
  return {
    attributes: newAttributes ? newAttributes : {},
    amUserId,
    contact: form.accountContact || data.contact,
    created: data.created || form.created,
    contractName: form?.contractName,
    contractNumber: form?.contractNumber,
    pacContractId: form?.pacContractId,
    // garageNumber: form?.garageNumber,
    garageNumber: form?.garage
      ? form?.garage.garageNumber
      : form?.garageNumber
      ? form?.garageNumber
      : "",

    vatPercentage: form?.vatPercentage || 0,
    ...(form?.userType === 3 ? { markup: form?.markup || 0 } : {}),
    contractStartDate: form?.contractStartDate || "",
    contractEndDate: form?.contractEndDate || "",
    settleDate: form?.settleDate || "",
    defaultSatisfactionDate: form?.defaultSatisfactionDate || "",
    customerNumber: form?.customerNumber || "",
    creditLimit:form.status==="advance"?0:form?.creditLimit || 0,
    creditPeriod: form?.creditPeriod || "",
    // buildingNoArabic: form?.buildingNoArabic || '',
    description: form.accountDescription || data.description,
    email: form.accountEmail,
    id: data.id || 0,
    modified: data.modified || form.modified,
    name: form.accountName,
    parentId: data.parentId || 0,
    contractType: form?.contractType || 1,
    nameArabic: form?.nameArabic || "",
    monthlyRevenueTarget: form?.monthlyRevenueTarget||data?.monthlyRevenueTarget || "",
    monthlyRevenueTargets: form?.monthlyRevenueTargets || data?.monthlyRevenueTargets || {},
    yearlyRevenueTarget: form?.yearlyRevenueTarget,
    status: form?.status || "",
    settingId: data?.settingId || "",
    active: form.active ? true : false,
    activeDate:data?.activeDate||"",
    inactiveDate:data?.inactiveDate||""
  };
};

const parseLimitNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const num = parseInt(value, 10);
  return Number.isNaN(num) ? null : num;
};

const normalizePhoneDigits = (phone) => {
  if (phone === null || phone === undefined || phone === "") return "";
  const str = String(phone).trim();
  const numeric = Number(str);
  if (!Number.isNaN(numeric) && Number.isFinite(numeric)) {
    return String(Math.trunc(numeric));
  }
  return str.replace(/\D/g, "");
};

const isPhoneValidValue = (phone) =>
  /^\d{3,}$/.test(normalizePhoneDigits(phone));

const normalizeLimitValue = (value) =>
  value === undefined || value === null || value === "" ? 0 : value;

const isUnlimitedParentLimit = (limitData) =>
  parseLimitNumber(limitData?.remaningLimit) === -1;

const getCurrentLimitUsage = (usageData) => {
  if (!usageData || typeof usageData !== "object") return 0;
  return (
    (parseLimitNumber(usageData.count) || 0) +
    (parseLimitNumber(usageData.reserveLimit) || 0)
  );
};

const getParentAvailableLimit = (limitData) => {
  if (!limitData || typeof limitData !== "object") return null;
  if (isUnlimitedParentLimit(limitData)) return Infinity;
  const remaining = parseLimitNumber(limitData.remaningLimit);
  const total = parseLimitNumber(limitData.totalCount) || 0;
  if (remaining === null) return null;
  return remaining - total;
};

const validateEditedLimit = ({
  value,
  parentLimits,
  usageLimits,
  originalLimit,
  parentErrorMessage,
  usageErrorMessage,
}) => {
  const numValue = parseLimitNumber(value);

  if (numValue === null) {
    const minUsage = getCurrentLimitUsage(usageLimits);
    if (minUsage > 0) {
      return { valid: false, message: usageErrorMessage };
    }
    return { valid: true, message: "" };
  }

  if (numValue === -1) {
    return isUnlimitedParentLimit(parentLimits)
      ? { valid: true, message: "" }
      : { valid: false, message: parentErrorMessage };
  }

  if (numValue < getCurrentLimitUsage(usageLimits)) {
    return { valid: false, message: usageErrorMessage };
  }

  const parentAvailable = getParentAvailableLimit(parentLimits);
  if (parentAvailable === Infinity || parentAvailable === null) {
    return { valid: true, message: "" };
  }

  const original =
    parseLimitNumber(originalLimit) !== null && parseLimitNumber(originalLimit) > -1
      ? parseLimitNumber(originalLimit)
      : 0;
  const maxAllowed = parentAvailable + original;

  if (numValue > maxAllowed) {
    return { valid: false, message: parentErrorMessage };
  }

  return { valid: true, message: "" };
};

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  button: {
    // margin: theme.spacing(1),
  },
});
let uploadFilesArray = [];
class updateUserDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      units: "",
      form: {
        ...this.props.selectedUser,
        accountName:
          this.props.selectedAccount?.name ||
          this.props.selectedUser?.extraInfo?.accountName,
        accountEmail:
          this.props.selectedAccount?.email ||
          this.props.selectedUser?.extraInfo?.accountEmail ||
          "",
        deviceLimit: this.props.selectedUser?.deviceLimit ?? 0,
        userLimit: this.props.selectedUser?.userLimit ?? 0,
        vehicleLimit: this.props.selectedUser?.vehicleLimit ?? 0,
        phone: this.props.selectedUser?.phone ?? "",
        accountDescription: this.props.selectedAccount?.description || "",
        accountContact: this.props.selectedAccount?.contact || "",
        contractName: this.props.selectedAccount?.contractName || "",
        customerNumber: this.props.selectedAccount?.customerNumber || "",
        contractNumber: this.props.selectedAccount?.contractNumber || "",
        pacContractId: this.props.selectedAccount?.pacContractId || "",

        garageNumber: this.props.selectedAccount?.garageNumber || "",

        vatPercentage: this.props.selectedAccount?.vatPercentage || 0,
        markup: this.props.selectedAccount?.markup || 0,
        // status: this.props.selectedAccount?.status || 0,
        contractEndDate: this.props.selectedAccount?.contractEndDate || "",
        contractStartDate: this.props.selectedAccount?.contractStartDate || "",
        settleDate: this.props.selectedAccount?.settleDate || "",
        defaultSatisfactionDate:
          this.props.selectedAccount?.defaultSatisfactionDate || "",
        creditLimit: this.props.selectedAccount?.creditLimit || "",
        creditPeriod: this.props.selectedAccount?.creditPeriod || "",
        status: this.props.selectedAccount?.status || "",
        contractType: this.props.selectedAccount?.contractType || 1,
        nameArabic: this.props.selectedAccount?.nameArabic || "",
        monthlyRevenueTarget: this.props.selectedAccount?.monthlyRevenueTarget,
        yearlyRevenueTarget: this.props.selectedAccount?.yearlyRevenueTarget,
        active: this.props.selectedAccount?.active ? true : false,
        created: this.props.selectedAccount?.created,
        modified: this.props.selectedAccount?.modified,
        amUserId:
          this.props.selectedAccount?.amUserId ??
          this.props.selectedUser?.amUserId ??
          null,
      },
      accountsform: this.props.selectedAccount?.attributes || {},
      selectedUser: this.props.selectedUser,
      citySelectedData:
 this.props.selectedUser?.city && typeof this.props.selectedUser.city === "object"
    ? this.props.selectedUser.city
    : this.props.cities?.find(
        (city) => city.id == this.props.selectedUser?.city
      ) || null,
      accountsFormCity:
 this.props.selectedAccount?.attributes?.c_city && typeof this.props.selectedAccount?.attributes?.c_city === "object"
    ? this.props.selectedAccount?.attributes?.c_city
    : this.props.cities?.find(
        (city) => city.id == this.props.selectedAccount?.attributes?.c_city
      ) || null,
      isVisableUserBtn: false,
      duplicateEntry: false,
      userLimit: true,
      vehicleLimit: true,
      deviceLimitError: false,
      userLimitError: false,
      vehicleLimitError: false,
      unitsLimitsMeaasge: "",
      vehicleLimitsMeaasge: "",
      usersLimitsMeaasge: "",
      vehicleLimitsMeaasge: "",
      currentUserRole: [],
      localPostionObj: "",
      isVisableAddlocBtn: false,
      editOption: true,
      updateOption: true,
      notVisableBackbtn: true,
      uploadDoc: [],
      filesData: [],
      emailInvalidError: "",
      accountEmailInvalidError: "",
      markupError: "",
      newField: "",
      addUserFieldErrors: {},
      phoneError: "",
    };
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.uu_submit = this.uu_submit.bind(this);
    this.generateToken = this.generateToken.bind(this);
    this.timeDateOnchange = this.timeDateOnchange.bind(this);
    this.changeAttribute2 = this.changeAttribute2.bind(this);
  }

  componentWillMount() {
    const c_schemeIdList = [
      { key: 1, name: "TIN" },
      { key: 2, name: "CRN" },
      { key: 3, name: "MOM" },
      { key: 4, name: "MLS" },
      { key: 5, name: "700" },
      { key: 6, name: "SAG" },
      { key: 7, name: "NAT" },
      { key: 8, name: "GCC" },
      { key: 9, name: "IQA" },
      { key: 10, name: "OTH" },
    ];
       if(this.props.selectedAccount.contractType){
      this.fetchAccountManagersList()
    }
    this.fetchVehiclesList()
    if (this.props.selectedAccount?.attributes.c_schemeId) {
      const selectedScheme = c_schemeIdList.find(
        (scheme) =>
          scheme.name === this.props.selectedAccount?.attributes.c_schemeId
      );
      if (selectedScheme) {
        // Dynamically set the value of the second field based on the selected scheme ID
        const newFieldName = `c_schemeNumber`;

        this.setState({
          newField: this.props.selectedAccount?.attributes[newFieldName] || "",
          accountsform: {
            ...this.state.accountsform,
            // [name]: value,
            [newFieldName]:
              this.props.selectedAccount?.attributes[newFieldName] || "",
            // Initialize the value of the new field
          },
        });
      }
    }

    this.setState({
      uploadDoc: [],
      filesData: [],
    });
    uploadFilesArray = [];
  }

  componentDidMount() {
    this.syncLimitValidationFromForm();
  }

  componentDidUpdate(prevProps, prevState) {
    const current = this.state.addUserFieldErrors;
    if (current && Object.keys(current).length) {
      const nowErrors = this.computeEditUserFieldErrors();
      const staleKeys = Object.keys(current).filter((k) => !nowErrors[k]);
      if (staleKeys.length) {
        const next = { ...current };
        staleKeys.forEach((k) => {
          delete next[k];
        });
        this.setState({
          addUserFieldErrors: Object.keys(next).length ? next : {},
        });
      }
    }

    const limitsReady =
      this.props.pUnitLimits &&
      typeof this.props.pUnitLimits === "object" &&
      this.props.pUserLimits &&
      typeof this.props.pUserLimits === "object" &&
      this.props.selectedUnitsLimits &&
      typeof this.props.selectedUnitsLimits === "object" &&
      this.props.selectedUserLimits &&
      typeof this.props.selectedUserLimits === "object";

    if (
      limitsReady &&
      (prevProps.pUnitLimits !== this.props.pUnitLimits ||
        prevProps.pUserLimits !== this.props.pUserLimits ||
        prevProps.selectedUnitsLimits !== this.props.selectedUnitsLimits ||
        prevProps.selectedUserLimits !== this.props.selectedUserLimits)
    ) {
      this.syncLimitValidationFromForm();
    }
  }

  setLimitErrorState = (type, { valid, message }) => {
    const config = {
      device: { error: "deviceLimitError", message: "unitsLimitsMeaasge" },
      user: { error: "userLimitError", message: "usersLimitsMeaasge" },
      vehicle: { error: "vehicleLimitError", message: "vehicleLimitsMeaasge" },
    }[type];

    if (!config) return;

    this.setState({
      [config.error]: !valid,
      [config.message]: valid ? "" : message,
    });
  };

  validateDeviceLimitValue = (value) => {
    const normalizedValue = normalizeLimitValue(value);
    if (parseLimitNumber(normalizedValue) === -1) {
      return { valid: true, message: "" };
    }
    return validateEditedLimit({
      value: normalizedValue,
      parentLimits: this.props.pUnitLimits,
      usageLimits: this.props.selectedUnitsLimits,
      originalLimit: this.props.selectedUser?.deviceLimit,
      parentErrorMessage: "deviceLimitErrorParent",
      usageErrorMessage: "deviceLimitError",
    });
  };

  validateUserLimitValue = (value) =>
    validateEditedLimit({
      value: normalizeLimitValue(value),
      parentLimits: this.props.pUserLimits,
      usageLimits: this.props.selectedUserLimits,
      originalLimit: this.props.selectedUser?.userLimit,
      parentErrorMessage: "userLimitErrorParent",
      usageErrorMessage: "userLimitError",
    });

  validateVehicleLimitValue = (value) =>
    validateEditedLimit({
      value,
      parentLimits: this.props.pUserLimits,
      usageLimits: null,
      originalLimit: this.props.selectedUser?.vehicleLimit,
      parentErrorMessage: "vehicleLimitErrorParent",
      usageErrorMessage: "userLimitError",
    });

  applyLimitFieldValidation = (fieldName, value) => {
    const validators = {
      deviceLimit: () => this.validateDeviceLimitValue(value),
      userLimit: () => this.validateUserLimitValue(value),
      vehicleLimit: () => this.validateVehicleLimitValue(value),
    };

    const types = {
      deviceLimit: "device",
      userLimit: "user",
      vehicleLimit: "vehicle",
    };

    if (!validators[fieldName]) return;

    const result = validators[fieldName]();
    this.setLimitErrorState(types[fieldName], result);
  };

  syncLimitValidationFromForm = () => {
    const { form } = this.state;
    this.applyLimitFieldValidation("deviceLimit", form.deviceLimit);
    this.applyLimitFieldValidation("userLimit", form.userLimit);
    if (form.userType === 1) {
      this.applyLimitFieldValidation("vehicleLimit", form.vehicleLimit);
    }
  };

  handleChange2 = (name) => (event) => {
    if (!event) {
      // Handle the case where event is null (e.g., when clearing the input)
      this.setState({
        [name]: null,
      });
      return;
    }

if (name === "name" || name === "accountName") {
  let value = event.target.value;
  value = value.replace(/[^A-Za-z0-9_\u0600-\u06FF ]/g, "");

  this.setState(
    {
      form: {
        ...this.state.form,
        [name]: value,
      },
    },
    () => this.checkRequiredFields()
  );

  return;
}
          if (name === "status") {
  this.setState(
    {
      form: {
        ...this.state.form,
        [name]: event.target.value,
        creditLimit: 0,
      },
      accountsform: {
        ...this.state.accountsform,
        c_agreedAdvancePayment: 0.0,
      },
    }
  );
  return;
}

    const { target } = event;
    if (target && target.type === "checkbox") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: target.checked,
          },
        },
        () => this.checkRequiredFields()
      );
    } else if (
      name === "expirationTime" ||
      name === "contractStartDate" ||
      name === "defaultSatisfactionDate" ||
      name === "settleDate" ||
      name === "contractEndDate"
    ) {
      const dateValue = event ? event.toISOString() : null;
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: dateValue,
          },
        },
        () => this.checkRequiredFields()
      );
    } else {
      let value = target?.value;
      if (target?.type === "number") {
        value = value === "" ? "" : parseFloat(value);
      }

      if (
        name === "deviceLimit" ||
        name === "userLimit" ||
        name === "vehicleLimit"
      ) {
        this.applyLimitFieldValidation(name, value);
      }

      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value,
          },
        },
        () => {
          this.checkRequiredFields();
          if (name === "phone") {
            this.validatePhone(value);
          }
        },
      );
    }
  };

  handleChangeAttributes = (name) => (event) => {
    const c_schemeIdList = [
      { key: 1, name: "TIN" },
      { key: 2, name: "CRN" },
      { key: 3, name: "MOM" },
      { key: 4, name: "MLS" },
      { key: 5, name: "700" },
      { key: 6, name: "SAG" },
      { key: 7, name: "NAT" },
      { key: 8, name: "GCC" },
      { key: 9, name: "IQA" },
      { key: 10, name: "OTH" },
    ];

  let value;
  if (event.target.type === "checkbox") {
    value = event.target.checked; // ✅ true/false
  } else if (name === "c_agreedAdvancePayment") {
    value = parseFloat(event.target.value);
  } else {
    value = event.target.value;
  }

  if (name === "c_schemeId") {
    const selectedScheme = c_schemeIdList.find(
      (scheme) => scheme.name === value
    );
    if (selectedScheme) {
      const newFieldName = `c_schemeNumber`;
      this.setState({
        accountsform: {
          ...this.state.accountsform,
          [name]: value,
          [newFieldName]: "", // Initialize the value of the new field
        },
      });
    }
  } else if (name === "number") {
    this.setState({
      newField: value,
      accountsform: {
        ...this.state.accountsform,
        [`c_schemeNumber`]:
          value,
      },
    });
  } else {
    // For other fields (text, number, checkbox, etc.)
    this.setState(
      {
        accountsform: {
          ...this.state.accountsform,
          [name]: value,
        },
      },
      () => {
        this.checkRequiredFields();
      }
    );
  }
};
validatePhone = (phone) => {
  const isValid = isPhoneValidValue(phone);

  if (!isValid) {
    this.setState({ phoneError: "Enter at least 3 digits" });
    return false;
  }

  this.setState({ phoneError: "" });
  return true;
};

computeEditUserFieldErrors() {
  const errors = {};
  const { form, accountsform } = this.state;
  const userType = Number(form.userType);
  const name = String(form.name ?? "").trim();
  const nameArabic = String(form.nameArabic ?? "").trim();
  const email = String(form.email ?? "").trim();
  const accountEmailTrim = String(form.accountEmail ?? "").trim();
  const accountNameTrim = String(form.accountName ?? "").trim();
  const roleId = form.roleId;
  const isPhoneValid = isPhoneValidValue(form.phone);
  const zoomNum =
    form.zoom === "" || form.zoom === null || form.zoom === undefined
      ? NaN
      : Number(form.zoom);
  const zoomValid = zoomNum > 2 && zoomNum < 19;
  // const postalTrim = String(accountsform.c_postalCode ?? "").trim();
  // const isValidAttributes = postalTrim !== "";

  if (!name) errors.name = true;
  if (!email) errors.email = true;
  else if (!validEmailPattern.test(email)) errors.email = true;



  if (!isPhoneValid) errors.phone = true;

  if (
    form.vatPercentage !== undefined &&
    form.vatPercentage !== null &&
    form.vatPercentage !== ""
  ) {
    const vatNum = Number(form.vatPercentage);
    if (Number.isNaN(vatNum) || vatNum < 0 || vatNum > 100) {
      errors.vatPercentage = true;
    }
  }

  if (userType === 3) {
      if (accountEmailTrim && !validEmailPattern.test(form.accountEmail)) {
    errors.accountEmail = true;
  }
    if (!accountNameTrim) errors.accountName = true;
    if (!accountEmailTrim) errors.accountEmail = true;
    if (!form.amUserId && !this.state.managerAccountSelect?.id) {
      errors.amUserId = true;
    }
    // if (!isValidAttributes) errors.c_postalCode = true;
  if(!nameArabic)errors.nameArabic=true
    if (form.markup !== undefined && form.markup !== null) {
      const markupNum = Number(form.markup);
      if (Number.isNaN(markupNum) || markupNum < 0 || markupNum > 100) {
        errors.markup = true;
      }
    }
  } else if (userType === 4) {
    if (!accountEmailTrim) errors.accountEmail = true;
    else if (!validEmailPattern.test(accountEmailTrim)) errors.accountEmail = true;
    if (!accountNameTrim) errors.accountName = true;
    if (!String(form.contractName ?? "").trim()) errors.contractName = true;
    if (!form.status) errors.status = true;
  } else if (userType === 1 || userType === 2) {
    if (!roleId) errors.roleId = true;
    if (!zoomValid) errors.zoom = true;
    if (!accountNameTrim) errors.accountName = true;
  } else if (userType === 5 || userType === 6) {
          if (accountEmailTrim && !validEmailPattern.test(form.accountEmail)) {
    errors.accountEmail = true;
  }
    if (!roleId) errors.roleId = true;
    if (!zoomValid) errors.zoom = true;
    if (!accountEmailTrim) errors.accountEmail = true;
    if (!accountNameTrim) errors.accountName = true;
    if (!String(accountsform.c_taxNumber ?? "").trim()) errors.c_taxNumber = true;
    // if (!isValidAttributes) errors.c_postalCode = true;
  }

  if (form.contractStartDate && form.contractEndDate) {
    const start = new Date(form.contractStartDate);
    const end = new Date(form.contractEndDate);
    if (start > end) errors.contractEndDate = true;
  }

  return errors;
}

checkRequiredFields() {
  let valid = true;
  let showButton = false;

  const {
    name,
    email,
    roleId,
    userType,
    zoom,
    accountEmail,
    accountName,
    contractStartDate,
    contractEndDate,
    vatPercentage,
    markup,
    phone,
    contractName,
    status,
  } = this.state.form;
  const isPhoneValid = isPhoneValidValue(phone);
  const userTypeNum = Number(userType);
 let {
      c_taxNumber,
      c_streetName,
      c_buildingNo,
      c_schemeId,
      c_city,
      c_postalCode,
      c_country,
      c_district,
      c_address,
      c_addressArabic,
      c_streetNameArabic,
      c_districtArabic,
      c_cityArabic
    } = this.state.accountsform;
const fields = [
  // c_postalCode,
  // c_address,
  // c_addressArabic,
  // c_streetName,
  // c_streetNameArabic,
  // c_district,
  // c_districtArabic,
  // c_city,
  // c_cityArabic,
];
// const isValidAttributes = fields.every(
//   v => String(v ?? "").trim() !== ""
// );



  if (email && !validEmailPattern.test(email)) {
    this.setState({ emailInvalidError: "Please enter a valid email address." });
    valid = false;
  } else {
    this.setState({ emailInvalidError: "" });
  }

  if (accountEmail && !validEmailPattern.test(accountEmail)) {
    this.setState({ accountEmailInvalidError: "Please enter a valid email address." });
    valid = false;
  } else {
    this.setState({ accountEmailInvalidError: "" });
  }

  const value = !isEqual(this.state.form, this.props.selectedUser);
  const noLimitError = !this.state.deviceLimitError && !this.state.userLimitError;
  const zoomValid = zoom > 2 && zoom < 19;
  if (userTypeNum === 1 || userTypeNum === 2) {
    if (
      name && email && userType && roleId && value &&
      zoom && accountEmail && accountName &&
      zoomValid && noLimitError&&isPhoneValid
    ) {
      showButton = valid;
    }
  } else if (userTypeNum === 4) {
    if (
      name &&
      email &&
      accountEmail &&
      accountName &&
      contractName &&
      status &&
      isPhoneValid &&
      noLimitError
    ) {
      showButton = true;
    }
  } else if (userTypeNum === 3) {
    if (
      name?.trim() &&
      email?.trim() &&
      accountEmail?.trim() &&
      markup >= 0 &&
      markup <= 100 &&
      // isValidAttributes &&
      isPhoneValid &&
      (this.state.form?.amUserId || this.state.managerAccountSelect?.id)
    ) {
      showButton = true;
    }
  } else {
    if (
      name && email && userType && roleId && value &&
      zoom && accountEmail && c_taxNumber &&
      // c_streetName && c_buildingNo && c_city &&

      // c_postalCode &&
      //  c_country && c_district &&
      accountName && zoomValid && noLimitError&&isPhoneValid
    ) {
      showButton = valid;
    }
  }
  if (vatPercentage !== undefined && vatPercentage !== null) {
    if (vatPercentage >= 0 && vatPercentage <= 100) {
      this.setState({ vatPercentageError: "" });
    } else {
      this.setState({
        isVisableUserBtn: false,
        vatPercentageError: "Enter Value between 0 and 100",
      });
      return;
    }
  }
  if (userType === 3 && markup !== undefined && markup !== null) {
    if (markup >= 0 && markup <= 100) {
      this.setState({ markupError: "" });
    } else {
      this.setState({
        isVisableUserBtn: false,
        markupError: "Enter Value between 0 and 100",
      });
      return;
    }
  } else {
    this.setState({ markupError: "" });
  }

  if (contractStartDate && contractEndDate) {
    const start = new Date(contractStartDate);
    const end = new Date(contractEndDate);
    if (start > end) {
      this.setState({
        isVisableUserBtn: false,
        contractEndDateError: "Contract end date must be after contract start date",
      });
      return;
    } else {
      this.setState({ contractEndDateError: "" });
    }
  }

  this.setState({
    isVisableUserBtn: showButton,
    // duplicateEntry: !showButton,
  });
}


  changeAttribute2(name, event) {
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    if (!value) {
      let a = { ...this.state.form.attributes };
      delete a[name];
      if (!Object.keys(a).length) {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes:
                this.props.selectedUser.attributes === null ? null : {},
            },
          },
          () => this.checkRequiredFields()
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...a,
              },
            },
          },
          () => this.checkRequiredFields()
        );
      }
    } else {
      if (name === "parking.minIdleTime") {
        value = parseFloat(value);
      }
      if (name === "parking.maxIdleSpeed") {
        value = parseFloat(value);
      }
      if (name === "measurementStandard") {
        let data = checkUnitsWithStandardType(value);
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...this.state.form.attributes,
                [name]:
                  event.target.type === "number" ? parseInt(value) : value,
                distanceUnit: data[0].distanceUnit.key,
                speedUnit: data[0].speedUnit.key,
                volumeUnit: data[0].volumeUnit.key,
              },
            },
          },
          () => this.checkRequiredFields()
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...this.state.form.attributes,
                [name]: value,
              },
            },
          },
          () => this.checkRequiredFields()
        );
      }
    }
  }
    fetchAccountManagersList = () => {
        const fetchApi = `/api/users/getAllUsersInSystem?search=&userTypes=4`;
        fetch(fetchApi, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (response.ok) {
              response.json().then((res) => {
                if (res.status === "success") {
                  const list = Array.isArray(res?.data?.data)
                    ? res.data.data
                    : Array.isArray(res?.data)
                      ? res.data
                      : [];
                  let result = list.map((item) => {
                    const entity = item?.entity || item;
                    return {
                      id: entity.id,
                      label: entity.label || entity.name,
                      name: entity.label || entity.name,
                      value: entity.id,
                    };
                  });
                    const cAmId = getAmUserId({
                      account: this.props.selectedAccount,
                      user: this.props.selectedUser,
                      form: this.state.form,
                      managerAccountSelect: this.state.managerAccountSelect,
                    });
                    let selectedAccount = result?.find(
                      (item) => String(item?.id) === String(cAmId),
                    );
                    if (cAmId && !selectedAccount) {
                      const fallback = {
                        id: cAmId,
                        value: cAmId,
                        label:
                          this.state.managerAccountSelect?.name ||
                          this.state.managerAccountSelect?.label ||
                          String(cAmId),
                        name:
                          this.state.managerAccountSelect?.name ||
                          this.state.managerAccountSelect?.label ||
                          String(cAmId),
                      };
                      result = [...(result || []), fallback];
                      selectedAccount = fallback;
                    }
                  this.setState({
                    defaultAccountManagerList: result,
                    managerAccountSelect:selectedAccount
                  });
                } else if (res?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (res.statusCode) {
                  var err = res?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  toast.error(this.props.translate(err[1]));
                }
              });
            }
          })
          .catch((e) => {
            console.log("e =", e);
            //   this.props.dispatch(toast.error({
            //   message: 'somethingWentWrong',
            //   autoDismiss: 5
            // }))
          });
      };

      
        fetchVehiclesList = async () => {
  try {
    let fetchApi = `/api/vehicles/list?userId=${this.props.logInUser.id}&page=1&limit=100`;

    if (this.props.logInUser.userType === -1) {
      fetchApi = `/api/vehicles/list?userId=${this.props.logInUser.id}&page=1&limit=100`;
    }

    const response = await fetch(fetchApi, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const res = await response.json();

    if (res.status === "success") {
      let userlist = res.data;

      let result =
        userlist.data &&
        userlist.data.map((item) => ({
          id: item.id,
          label: item.label || item.name,
          name: item.label || item.name,
          value: item.id,
        }));
      const selectedAccount = result?.find(
        (item) => item?.id === this.props.selectedUser?.attributes?.vehicleId
      );
      this.setState({
        defaultVehiclesList: result,
        selectedVehicle: selectedAccount,
      });
    } else if (res?.statusCode === "440") {
      window.location.replace("/login");
    } else if (res.statusCode) {
      var err = res?.message.split(":");
      err[1] = err[1].replace(")", "");
      toast.error(this.props.translate(err[1]));
    }
  } catch (e) {
    console.log("Error in fetchVehiclesList =", e);
    // toast.error("Something went wrong");
  }
};

  timezone_handleChange = (name, value) => {
    if (name === "c_am" || name === "amUserId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            amUserId: value?.id ?? value?.value ?? null,
          },
          managerAccountSelect: value,
        },
        () => {
          this.checkRequiredFields();
        }
      );
      return;
    }
     if (name === "city") {
        this.setState(
          {
            form: {
              ...this.state.form,
              [name]: value.id,
            },
            citySelectedData: value,
          },
          () => {
            this.checkRequiredFields();
          }
        );
        return
      }
      if (name === "c_city") {
                this.setState(
      {
        accountsform: {
          ...this.state.accountsform,
          [name]: value.id,
          c_cityArabic:value?.cityAr||this.state.accountsform?.c_cityArabic
        },
        accountsFormCity:value
      },
      () => {
        this.checkRequiredFields();
      }
    );
    return
      }
        if (name === "vehicleId") {
      this.setState(
        {
          selectedVehicle: value,
        },
        () => {
          this.checkRequiredFields();
        }
      );
    }
    if (!value || value.value === "None") {
      if (this.state.form.attributes[name]) {
        delete this.state.form.attributes[name];
      }
      let a = { ...this.state.form.attributes };
      delete a[name];
      if (!Object.keys(a).length) {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes:
                this.props.selectedUser.attributes === null ? null : {},
            },
          },
          () => this.checkRequiredFields()
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...this.state.form.attributes,
              },
            },
          },
          () => this.checkRequiredFields()
        );
      }
    } else {
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: {
              ...this.state.form.attributes,
              [name]: value.value,
            },
          },
        },
        () => this.checkRequiredFields()
      );
    }
  };
  async handleVehicleChange(user) {
  const oldVehicleId = this.props.selectedUser?.attributes?.vehicleId;
  const newVehicleId = user?.attributes?.vehicleId;

  if (user && user?.userType === 1 && this.state.selectedVehicle) {
    if (oldVehicleId !== newVehicleId) {
      try {
        if (oldVehicleId) {
          await this.unitToUserpermission({
            userId: user?.id,
            vehicleId: oldVehicleId,
            method: "DELETE",
          });
        }

        if (newVehicleId) {
          await this.unitToUserpermission({
            userId: user?.id,
            vehicleId: newVehicleId,
          });
        }
      } catch (err) {
        toast.error(err?.message||"Vehicle change failed")
      }
    }
  }
}

  showLimitValidationError = () => {
    const { deviceLimitError, userLimitError, unitsLimitsMeaasge, usersLimitsMeaasge } =
      this.state;
    if (deviceLimitError && unitsLimitsMeaasge) {
      toast.error(this.props.translate(unitsLimitsMeaasge));
      return true;
    }
    if (userLimitError && usersLimitsMeaasge) {
      toast.error(this.props.translate(usersLimitsMeaasge));
      return true;
    }
    if (deviceLimitError || userLimitError) {
      toast.error(this.props.translate("emptyField"));
      return true;
    }
    return false;
  };

  uu_submit() {
    const fieldErrors = this.computeEditUserFieldErrors();
    if (Object.keys(fieldErrors).length > 0) {
      this.setState({ addUserFieldErrors: fieldErrors });
      toast.error(this.props.translate("emptyField"));
      return;
    }
    if (this.showLimitValidationError()) {
      return;
    }
    this.setState({ addUserFieldErrors: {} });

    const { selectedUser } = this.state;
    let { attributes } = this.state.form;
    let itemId = selectedUser.id;
      if(this.state.form.userType===1){
        attributes={...attributes,vehicleId:this.state.selectedVehicle?.id||""}
      }else{
        delete attributes.vehicleId
        delete attributes.isDriverActive
      }
      const obj = userDataFormat(this.state.form, attributes, itemId);
      const AccountObj = accountDataFormat(
        this.props.selectedAccount,
        this.state.form,
        this.state.accountsform
      );
      const amUserId = getAmUserId({
        managerAccountSelect: this.state.managerAccountSelect,
        form: this.state.form,
        account: this.props.selectedAccount,
        user: this.props.selectedUser,
      });
      if (this.state.form.userType === 3 && amUserId != null) {
        obj.amUserId = amUserId;
        AccountObj.amUserId = amUserId;
      }

      if (this.state.form.userType > 2) {
        fetch(`/api/accounts/${this.props.selectedAccount.id}`, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...AccountObj,
          }),
        })
          .then((response) => {
            if (response.ok) {
              response.json().then((res) => {
                let account = res.data;
                if (res.status === "success") {
                      // managedUserId permission call disabled
                      // const nextAmUserId = getAmUserId({ account: res?.data });
                      // const prevAmUserId = getAmUserId({
                      //   account: this.props.selectedAccount,
                      // });
                      // if (res?.data?.userId && nextAmUserId !== prevAmUserId) {
                      //   const managedUserId = res.data.userId;
                      //   const assignManager = () => {
                      //     if (nextAmUserId) {
                      //       return this.unitToUserpermission({
                      //         userId: nextAmUserId,
                      //         managedUserId,
                      //       });
                      //     }
                      //   };
                      //   if (prevAmUserId) {
                      //     this.unitToUserpermission({
                      //       userId: prevAmUserId,
                      //       managedUserId,
                      //       method: "DELETE",
                      //     }).finally(assignManager);
                      //   } else {
                      //     assignManager();
                      //   }
                      // }
                  this.setState(
                    {
                      form: {
                        ...this.state.form,
                        accountName: AccountObj?.name || "",
                        accountEmail: AccountObj?.email || "",
                        accountDescription: AccountObj?.description || "",
                        accountContact: AccountObj?.contact || "",
                        contractName: AccountObj?.contractName || "",
                        customerNumber: AccountObj?.customerNumber || "",
                        contractNumber: AccountObj?.contractNumber || "",
                        pacContractId: AccountObj?.pacContractId || "",

                        garageNumber: AccountObj?.garageNumber || "",

                        vatPercentage: AccountObj?.vatPercentage || 0,
                        markup: AccountObj?.markup || 0,
                        contractEndDate: account?.contractEndDate || "",
                        contractStartDate: account?.contractStartDate || "",
                        settleDate: account?.settleDate || "",
                        defaultSatisfactionDate:
                          account?.defaultSatisfactionDate || "",
                        creditLimit: AccountObj?.creditLimit || "",
                        creditPeriod: AccountObj?.creditPeriod || "",
                        nameArabic: AccountObj?.nameArabic || "",
                        monthlyRevenueTarget: AccountObj?.monthlyRevenueTarget,
                        yearlyRevenueTarget: AccountObj?.yearlyRevenueTarget,
                        status: AccountObj.status || "",
                      },
                    },
                    () => {
                      this.props.updateSelectedAccount(account);
                    }
                  );
                  this.props.dispatch(updateAccount(account));
                  // form: { ...this.props.selectedUser, accountEmail:this.props.selectedUser&&this.props.selectedUser.extraInfo&&this.props.selectedUser.extraInfo.accountEmail },
                  if (this.props.selectedAccount.id === 1) {
                    this.props.dispatch(ServerInfo(account));
                  }
                } else if (res?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (res.statusCode) {
                  var err = res?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  // this.props.dispatch(
                  toast.error(this.props.translate(err[1]));
                }
              });
            }
          })
          .catch((e) => {
            toast.error(this.props.translate("somethingWentWrong"));
          });
      }
      fetch(`/api/users/${itemId}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...obj,
        }),
      })
        .then((response) => {
          response.json().then((res1) => {
            if (res1.status === "success") {
              let user = res1.data;
              let parent = {
                parentId: this.props.logInUser.id,
                parentName: this.props.logInUser.name,
              };
              user = { ...user, ...parent };
                  if(user&&user?.userType===1&&this.state.selectedVehicle){
                  this.handleVehicleChange(user)
                }
              this.props.dispatch(updateUser(user));
              this.props.UpdateSelectedItem(user);
              if (
                parseInt(this.props.selectedUser.parentId) ===
                parseInt(this.props.logInUser.id)
              ) {
                this.getUsersLimits();
              }
              toast.success(this.props.translate("userIsUpdated"));
              this.setState({
                // form: { ...user},
                form: {
                  ...user,
                  ...this.state.form,
                  // accountName: AccountObj?.name || "",
                  // accountEmail: AccountObj?.email || "",
                  // accountDescription: AccountObj?.description || "",
                  // accountContact: AccountObj?.contact || "",
                  // nameArabic: AccountObj?.nameArabic || "",
                  // contractType: AccountObj?.contractType || "",
                },
                selectedUser: user,
                isVisableUserBtn: false,
                addUserFieldErrors: {},
              });
            } else if (res1?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res1.statusCode) {
              var err = res1?.message.split(":");
              err[1] = err[1].replace(")", "");
              toast.error(this.props.translate(err[1]));
            }
          });
        })
        .catch((e) => {
          toast.error("somethingWentWrong");
        });
  }
unitToUserpermission({ userId, managedUserId, vehicleId, method = "POST" }) {
  let obj = { userId };

  if (managedUserId) obj.managedUserId = managedUserId;
  if (vehicleId) obj.vehicleId = vehicleId;

  return fetch(`/api/permissions`, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj),
  })
    .then((response) => response.json())
    .then((res) => {
      if (res.status === "success") {
        toast.success(
          this.props.translate(
            method === "POST"
              ? "userIsAssignedSuccessfully"
              : "userIsUnAssignedSuccessfully"
          )
        );
      } else if (res?.statusCode === "440") {
        window.location.replace("/login");
      } else if (res?.statusCode) {
        let err = res.message.split(":");
        let err2 = err[1].split("&#");
        toast.error(this.props.translate(err2[0]));
      } else {
        throw res;
      }
      return res; // ✅ so callers can chain or await
    })
    .catch((e) => {
      if (e && e.text) {
        e.text().then((err) => {
          if (err.includes("You cannot unlink unit")) {
            this.props.dispatch(
              toast.error(this.props.translate("youCannotUnlinkUnit"))
            );
          }
        });
      }
      throw e; // ✅ propagate error
    });
}




  getUsersLimits = () => {
    if (this.props.logInUser.id) {
      //units limits
      if (checkPrivileges("device")) {
        fetch(`/api/devices/count?userId=${this.props.logInUser.id}`)
          .then((response) => {
            if (response.ok) {
              response.json().then((res) => {
                if (res.status === "success") {
                  this.props.dispatch(parentUnitsLimit(res.data));
                } else if (res?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (res.statusCode) {
                  var err = res?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  toast.error(this.props.translate(err[1]));
                }
              });
            } else {
              throw response;
            }
          })
          .catch((e) => {});
      }
      //users limits
      if (checkPrivileges("user")) {
        fetch(`/api/users/count?userId=${this.props.logInUser.id}`)
          .then((response) => {
            if (response.ok) {
              response.json().then((res) => {
                if (res.status === "success") {
                  this.props.dispatch(parentUsersLimit(res.data));
                } else if (res?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (res.statusCode) {
                  var err = res?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  toast.error(this.props.translate(err[1]));
                }
              });
            } else {
              throw response;
            }
          })
          .catch((e) => {});
      }
    }
  };
  generateToken() {
    let symbols =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let i,
      newToken = "";
    for (i = 0; i < 32; i++) {
      newToken += symbols.charAt(Math.floor(Math.random() * symbols.length));
    }
    this.setState(
      {
        form: {
          ...this.state.form,
          token: newToken,
        },
      },
      () => this.checkRequiredFields()
    );
  }
  timeDateOnchange(date) {
    this.setState((preState) => ({
      ...preState,
      form: {
        ...preState.form,
        timeDate: date,
      },
    }));
  }
  setExpirationTime = (e) => {
    e.stopPropagation();
    if (this.state.form.expirationTime) {
      this.setState(
        {
          form: {
            ...this.state.form,
            expirationTime: null,
          },
        },
        () => this.checkRequiredFields()
      );
    }
  };
  handleClickShowPostion = () => {
    this.setState({
      isMapModal: true,
      isVisableAddlocBtn: false,
    });
  };
  getPostion = (latlng, zoom) => {
    if (latlng.lat && latlng.lng && zoom) {
      this.setState({
        localPostionObj: { latlng, zoom },
        isVisableAddlocBtn: true,
      });
    }
  };
  setNoToken = (e) => {
    e.stopPropagation();
    this.setState(
      {
        form: {
          ...this.state.form,
          token: null,
        },
      },
      () => this.checkRequiredFields()
    );
  };
  setSelectedLocation = () => {
    const { localPostionObj } = this.state;
    if (localPostionObj) {
      this.setState(
        {
          form: {
            ...this.state.form,
            latitude: localPostionObj.latlng.lat,
            longitude: localPostionObj.latlng.lng,
            zoom: localPostionObj.zoom,
          },
          isMapModal: false,
        },
        () => this.checkRequiredFields()
      );
    }
  };
  onCloseModal = () => {
    this.setState({
      isMapModal: false,
    });
  };

  filesDataPrepare = async () => {
    const fieldErrors = this.computeEditUserFieldErrors();

    if (Object.keys(fieldErrors).length > 0) {
      this.setState({ addUserFieldErrors: fieldErrors });
      toast.error(this.props.translate("emptyField"));
      return;
    }
    if (this.showLimitValidationError()) {
      return;
    }
    this.setState({ addUserFieldErrors: {} });

    let { filesData } = this.state;

    if (filesData && filesData.length > 0) {
      for (let i = 0; i < filesData.length; i++) {
        await instance({
          url: `/api/uploads`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            ...filesData[i],
          },
        })
          .then((res) => {})
          .catch((error) => {
            errorHandler(error, this.props.dispatch);
          });
      }
      this.uu_submit();
    } else {
      this.uu_submit();
    }
  };
  removeFiles = (key) => {
    let updatedFilesData = [...this.state.filesData];
    updatedFilesData.splice(key, 1);
    uploadFilesArray.splice(key, 1);
    this.setState(
      {
        filesData: updatedFilesData,
        uploadDoc: uploadFilesArray,
      },
      () => this.checkRequiredFields()
    );
  };

  uploadFiles = (e) => {
    const files = e.target.files;
    let prevSavedImages = this.props.userFilesData
      ? this.props.userFilesData
      : [];
    let prevUploadedImages = this.state.uploadDoc ? this.state.uploadDoc : [];

    if (
      prevSavedImages.length + prevUploadedImages.length + files.length <=
      5
    ) {
      Object.values(files).forEach((item) => {
        if (item.size <= 5 * 1024 * 1024) {
          let reader = new FileReader();

          reader.onload = (e) => {
            let fileData = e.target.result;

            if (
              fileData.split(":")[1].split("/")[0] === "image" ||
              fileData
                .split(":")[1]
                .split("/")[1]
                .toLowerCase()
                .substring(0, 3) === "pdf" ||
              fileData
                .split(":")[1]
                .split("/")[1]
                .toLowerCase()
                .substring(0, 3) === "vnd"
            ) {
              uploadFilesArray.push(item.name);
              let obj = {
                name: `${item.name}`,
                contentType: `${item.type}`,
                oldUrl: fileData,
                entity: "User",
                entityId: this.state.selectedUser.id,
                data: `${fileData.split("base64")[1].substring(1)}`,
              };

              this.setState(
                (prevState) => ({
                  filesData: [...prevState.filesData, obj],
                  uploadDoc: [...uploadFilesArray],
                }),
                () => this.checkRequiredFields()
              );
            } else {
              toast.error(this.props.translate("onlyAcceptImagesDocs"));
            }
          };

          reader.readAsDataURL(item);
        } else {
          toast.error(this.props.translate("fileSize5MB"));
        }
      });
    } else {
      toast.error(this.props.translate("fileLimit"));
    }
  };
  changeLimit = (name, event) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    const { selectedUser } = this.props;

    this.setState(
      {
        [name]: value,
        form: {
          ...this.state.form,
          deviceLimit: value ? -1 : selectedUser?.deviceLimit ?? 0,
          vehicleLimit: value ? -1 : selectedUser?.vehicleLimit ?? 0,
          userLimit: value ? -1 : selectedUser?.userLimit ?? 0,
        },
        ...(value
          ? {
              deviceLimitError: false,
              userLimitError: false,
              vehicleLimitError: false,
              unitsLimitsMeaasge: "",
              usersLimitsMeaasge: "",
              vehicleLimitsMeaasge: "",
            }
          : {}),
      },
      () => {
        this.syncLimitValidationFromForm();
        this.checkRequiredFields();
      },
    );
  };

  handleChangeExpense = (name, value) => {
    if (name === "garage") {
      this.setState(
        {
          form: {
            ...this.state.form,
            garage: value,
          },
        },
        () => {
          this.checkRequiredFields();
        }
      );
    }
  };
  render() {
    return (
      <Fragment>
        <AddUserModal
          {...this.state}
          {...this.props}
          newField={this.state.newField}
          changeLimit={this.changeLimit}
          isVisableUserBtn={true}
          logInUser={this.props.logInUser}
          padding={"0px"}
          uploadImage={this.uploadImage}
          removeImage={this.removeImage}
          elevation={0}
          // formSubmit={this.uu_submit}
          formSubmit={this.filesDataPrepare}
          handleChangeExpense={this.handleChangeExpense}
          timeDateOnchange={this.timeDateOnchange}
          generateToken={this.generateToken}
          changeAttribute2={this.changeAttribute2}
          handleChange={this.handleChange2}
          buttonText={this.props.translate("update")}
          handleClickShowPostion={this.handleClickShowPostion}
          userType={this.props.logInUser.userType}
          setExpirationTime={this.setExpirationTime}
          setNoToken={this.setNoToken}
          roleTypes={this.props.roles}
          timezone_handleChange={this.timezone_handleChange}
          hasAccessOfUpdate={checkPrivileges("userUpdate")}
          hasAccessOfDelete={checkPrivileges("userDelete")}
          hasAccessOfCreate={checkPrivileges("userCreate")}
          usersLimit={
            getParentAvailableLimit(this.props.pUserLimits) ?? 0
          }
          vehicleLimit={
            getParentAvailableLimit(this.props.pUserLimits) ?? 0
          }
          deviceLimit={
            getParentAvailableLimit(this.props.pUnitLimits) ?? 0
          }
          createdUnits={this.props.selectedUnitsLimits.unitCount}
          createdUsers={this.props.selectedUnitsLimits.totalCount}
          handleChangeAttributes={this.handleChangeAttributes}
          uploadFiles={this.uploadFiles}
          removeFiles={this.removeFiles}
          uploadDoc={this.state.uploadDoc}
          userFilesData={this.props.userFilesData}
          removeUserFile={this.props.removeUserFile}
          addUserFieldErrors={this.state.addUserFieldErrors}
        />
        {this.state.isMapModal && (
          <CustomDialog
            title={this.props.translate("setLocation")}
            themeColors={this.props.themeColors}
            visable={true}
            onClose={this.onCloseModal}
            isButtonVisable={true}
            draggable={true}
            fullWidth
            CancelText={this.props.translate("sharedBack")}
            headerActions={
              <Button
                size="small"
                variant="contained"
                color="secondary"
                disabled={!this.state.isVisableAddlocBtn}
                onClick={() => this.setSelectedLocation()}
              >
                {" "}
                {this.props.translate("sharedAdd")}
              </Button>
            }
            bodyPadding={0}
          >
            <MarkerMap
              getPostion={this.getPostion}
              minHeight={500}
              zoom={this.state.selectedUser.zoom || 0}
              lat={this.state.selectedUser.latitude || 0}
              lng={this.state.selectedUser.longitude || 0}
              height={"100%"}
            />
          </CustomDialog>
        )}
      </Fragment>
    );
  }
}

const UpdateUserDetail = withStyles(styles);
export default UpdateUserDetail(updateUserDetail);
